import Dexie, { Table } from "dexie";

export interface PendingDelivery {
    id?: number;
    clientTxnId: string;
    shiftId: string;
    customerId: string;
    productId: string;
    fullGiven: number;
    emptyReceived: number;
    cashCollected: number;
    status: "PENDING" | "SYNCING" | "SYNCED" | "FAILED";
    createdAt: string;
    syncedAt?: string;
    error?: string;
}

export interface CachedCustomer {
    id: string;
    name: string;
    phone: string;
    address: string;
    areaId: string | null;
    cachedAt: string;
}

export interface CachedCustomerProduct {
    id: string;
    name: string;
    status: string;
    description: string | null;
    price: string;
    effectivePrice: number;
    hasPriceOverride: boolean;
}

export interface CachedCustomerDetail {
    customerId: string;
    customer: CachedCustomer;
    cashBalance: string;
    bottlesOnHand: number;
    products: CachedCustomerProduct[];
    cachedAt: string;
}

class RiderDatabase extends Dexie {
    pendingDeliveries!: Table<PendingDelivery>;
    cachedCustomers!: Table<CachedCustomer>;
    cachedCustomerDetail!: Table<CachedCustomerDetail>;

    constructor() {
        super("RiderDatabase");
        this.version(1).stores({
            pendingDeliveries: "++id, clientTxnId, shiftId, customerId, status, createdAt",
            cachedCustomers: "id, name, phone, areaId, cachedAt",
        });
        // v2: customer/shift/product IDs are UUID strings (were wrongly typed as number),
        // pendingDeliveries now carries a productId (multi-product deliveries), and
        // cachedCustomerDetail caches a customer's per-visit product list + pricing
        // offline (fetched once online via GET /rider/customers/:id).
        this.version(2).stores({
            pendingDeliveries:
                "++id, clientTxnId, shiftId, customerId, productId, status, createdAt",
            cachedCustomers: "id, name, phone, areaId, cachedAt",
            cachedCustomerDetail: "customerId, cachedAt",
        });
    }
}

export const db = new RiderDatabase();
